const recruitmentOptions = [
  { label: "Not yet recruiting", value: "b" },
  { label: "Recruiting", value: "a" },
  { label: "Enrolling by invitation", value: "f" },
  { label: "Active, not recruiting", value: "d" },
  { label: "Suspended", value: "g" },
  { label: "Terminated", value: "h" },
  { label: "Completed", value: "e" },
  { label: "Withdrawn", value: "i" },
  { label: "Unknown status", value: "m" }
];
// b, a, f, d, g, h, e, i, m

export { recruitmentOptions };



// WEBPACK FOOTER //
// ./src/data/recruitment.js